/**
 * create-data-export-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { SubjectContextType } from "../../../subjects/subject-context-type";
import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class CreateDataExportRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CREATE_DATA_EXPORT;
  public static tag : MessageTag = MessageTag.REQ_CREATE_DATA_EXPORT;

  /**
   * Construct a new {@link CreateDataExportRequest}.
   */
  constructor (
    public formatName : string,
    public algorithm : string,
    public subjectContextType : SubjectContextType,
    public groupId : number,
    public exportName : string = "new export"
  )
  {
    super();
  }

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_CREATE_DATA_EXPORT);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/create-data-export-request.ts